"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isStoreAddressExist = void 0;
const lodash_1 = require("lodash");
const isStoreAddressExist = (address = {}) => {
    const storeAddress = (0, lodash_1.cloneDeep)(address) || {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    storeAddress === null || storeAddress === void 0 ? true : delete storeAddress.__typename;
    return Object.values(storeAddress).some(a => !!a);
};
exports.isStoreAddressExist = isStoreAddressExist;
//# sourceMappingURL=address.js.map